import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./ClientComp/Header/NavBar";
import Footer from "./ClientComp/Footer/Footer";

const Layout = () => {
  const location = useLocation();
  
  // Cacher le Navbar et le Footer sur les pages Admin
  const hideNavbarAndFooter =
  [
    "/HomePageAdmin",
    "/GestionDesChambres",
    "/GestionDesReservations",
    "/NosClients",
    "/Calculator",
    "/RedactionArticle",
    "/EditionArticle",
  ].includes(location.pathname) ||
  /^\/EditSingleArticle\/[^/]+$/.test(location.pathname);

  return (
    <div className="App" style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {!hideNavbarAndFooter && <Navbar />}
      
      {/* Outlet permet d'afficher la page correspondante */}
      <Outlet />

      {!hideNavbarAndFooter && <Footer />}
    </div>
  );
};

export default Layout;
